import AdvancedSettings from '@/components/bot/AdvancedSettings'
import BotSettingsNavTabs from '@/components/bot/BotSettingsNavTabs'
import { Clock } from 'lucide-react'

export default function AdvancedBotSettings() {
  return (
    <div className="p-4 sm:p-6 overflow-x-hidden min-h-screen bg-slate-50">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#075E54]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <Clock className="w-5 h-5 text-[#075E54]" />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">Horarios de Atención y Disponibilidad</h1>
            <p className="text-xs sm:text-sm text-gray-600">
              Define los días y horas de atención de tu negocio, tu zona horaria y cómo debe responder el asistente fuera de turno.
            </p>
          </div>
        </div>
      </div>

      <BotSettingsNavTabs />

      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm">
        <AdvancedSettings />
      </div>
    </div>
  )
}
